import PropTypes from "prop-types"
import { Link } from "react-router-dom"

import Image from "components/ui/image"
import { to_currency } from "helpers/number"

import WishlistIcon from "./wishlist-icon"

const LineItem = ({ item }) => {
  return (
    <div className="relative">
      <Link className="block" to={item.modify_url}>
        <div className="border-grey-10 flex flex-col items-center border p-8">
          <Image
            alt={item.title}
            className="w-(--base-width) tablet:w-(--tablet-width)"
            height="512"
            src={item.image_url}
            style={{ "--base-width": "150px", "--tablet-width": "200px" }}
            width="512"
          />
          <h2
            className="text-18 leading-22 h-22 tablet:mt-8 tablet:px-8 mb-4 line-clamp-1 text-ellipsis"
            title={item.title}
          >
            {item.title}
          </h2>
          {item.on_sale ? (
            <p className="text-12 leading-14 mb-20 font-light">
              from (
              <strike className="font-medium">
                {to_currency(item.regular_price)}
              </strike>
              ){" "}
              <span className="text-sale font-medium">
                {to_currency(item.price)}
              </span>
            </p>
          ) : (
            <p className="text-12 leading-14 mb-20 font-medium">
              from {to_currency(item.price)}
            </p>
          )}
        </div>
      </Link>
      <WishlistIcon item={item} />
    </div>
  )
}

LineItem.propTypes = {
  item: PropTypes.object,
}

export default LineItem
